import React from 'react';
import { Link } from 'react-router-dom';

import { Box, Typography } from '@mui/material';

import { extractSubscriptionPlan } from '../../../pages/SubscriptionPlans/common/helper';
import { useAppSelector } from '../../../redux/hooks';
import { brandPromotionLimit } from '../../../utils/reservations';
import Button from '../../Button/Button';
import SvgIcon from '../../Icons';
import BaseDialog, { BaseDialogProps } from '../Base';

type Props = BaseDialogProps;

export const BrandLimitReachedPopup: React.FC<Props> = ({ ...rest }) => {
  const { subscription } = useAppSelector((state) => state.subscription.value);
  const venueState = useAppSelector((state) => state.venue.value);

  const subscriptionPlan = React.useMemo(() => {
    const [plan] = extractSubscriptionPlan(subscription?.sku ?? '');

    return plan;
  }, [subscription]);

  return (
    <BaseDialog width='450px' height='460px' titleComponent={<></>} {...rest}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        justifyContent={'space-around'}
        height={'100%'}
        px={3}
      >
        <Typography fontSize={'40px'} fontFamily={'Poppins'} fontWeight={600}>
          {(venueState?.totalConsumedPromotions ?? 0)}/{(venueState?.totalAllowedPromotions ?? 0)}
        </Typography>
        <Box display={'flex'} flexDirection={'column'} gap={'8px'} alignItems={'center'}>
          <Typography fontSize={'18px'} fontFamily={'Poppins'} fontWeight={500}>
            You’ve reached your promotion limit
          </Typography>
          <Typography fontSize={'15px'} fontFamily={'Poppins'} textAlign={'center'}>
            Upgrade your plan to keep receiving requests, or send paid Collabs anytime!
          </Typography>
        </Box>
        <Box display={'flex'} flexDirection={'column'} gap={'8px'} width={'100%'}>
          <Button
            color='primary'
            component={Link}
            to='/plans'
            id='btn-premium-plans'
            startIcon={<SvgIcon name='Plus' sx={{ fill: 'url(#linear-gradient)' }} />}
            variant='contained'
            sx={{
              py: 1.8,
            }}
            fullWidth
          >
            Upgrade your Plan
          </Button>
          <Button variant='text' fullWidth onClick={rest.onClose}>
            Cancel
          </Button>
        </Box>
      </Box>
    </BaseDialog>
  );
};
